import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ProfileFormProps {
  newName: string;
  setNewName: (name: string) => void;
  newAge: string;
  setNewAge: (age: string) => void;
  handleAddProfile: () => void;
  setIsAddingProfile: (value: boolean) => void;
}

const ProfileForm: React.FC<ProfileFormProps> = ({ 
  newName, 
  setNewName, 
  newAge, 
  setNewAge, 
  handleAddProfile, 
  setIsAddingProfile 
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="card mb-6 animate-scale-up">
      <div className="flex justify-between items-center mb-4">
        <h4 className="font-medium text-gray-800">{t('profile.newProfile')}</h4>
        <button 
          onClick={() => setIsAddingProfile(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">{t('profile.name')}</label>
          <input
            type="text"
            id="name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sangre-500"
            placeholder={t('profile.fullName')}
          />
        </div>
        
        <div>
          <label htmlFor="age" className="block text-sm font-medium text-gray-700 mb-1">{t('profile.age')}</label>
          <input
            type="number"
            id="age"
            value={newAge}
            onChange={(e) => setNewAge(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sangre-500"
            placeholder={t('profile.age')}
            min="1"
            max="120"
          />
        </div>
        
        <button 
          onClick={handleAddProfile}
          className="btn-primary w-full"
        >
          {t('profile.saveProfile')}
        </button>
      </div>
    </div>
  );
};

export default ProfileForm;
